<style scoped>
.row-line {
  height: 40px;
}


.td-label {
  width: 100px;
  margin-right: 10px;
}
.button-spacing {
  margin-right: 10px;
}

.expiration-time {
  color: red;
}
.expiration-text {
  margin-right: 10px;
}
.centered-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.verification-code {
  display: flex;
  justify-content: center;
  align-items: center;
}

.code-box {
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  margin: 5px;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.confirm-button {
  margin-left: 10px;
}

</style>

<template>
  <div>
    <Button type="success" icon="md-add" @click="showSubmitFrom">归档</Button>
    <Table
      :columns="tdata.col_data"
      :data="tdata.current_data"
      :loading="tdata.loading"
      style="margin-top:10px"
      @on-row-click="rowSelect"
    >
      <template slot-scope="{row}" slot="buildfrom">
        {{row.buildfrom == 1?'持续集成':'手动构建'}}
      </template>
      <template slot-scope="{row}" slot="disttype">
        {{row.disttype == 1?'正式发布':'测试发布'}}
      </template>
      <template slot-scope="{row}" slot="copy">
        <Button size="small" @click.stop="copy(row)">复制</Button>
        <span class="button-spacing"></span>
        <Button size="small" @click.stop="getcode(row)">下载码</Button>
      </template>      
    </Table>
    <Modal
      v-model="modal"
      title="Android安装包归档(apk)"
      @on-visible-change="onModalVisible"
      :mask-closable="false"
    >
      <div style="padding:10px">
        <table style="width:100%;">
          <tr class="row-line">
            <td class="td-label">apk上传</td>
            <td>
              <Upload
                ref="uploadApk"
                :format="['apk']"
                style="float:left"
                :action="fileUpload.uploadurl"
                :data="fileUpload.fileUploadParams"
                :headers="fileUpload.headers"
                :show-upload-list="true"
                :on-success="onApkFileUploadSuccess"
              >
                <Button
                  icon="ios-cloud-upload-outline"
                >选择文件</Button>
              </Upload>
              <span
                style="color:green;margin-left:10px;line-height:32px"
                v-if="fileUpload.hasUpload"
              >已上传</span>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">发布类型</td>
            <td>
              <RadioGroup v-model="submitModel.disttype">
                <Radio :label="1">正式发布</Radio>
                <Radio :label="0">测试发布</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">发布渠道</td>
            <td>
              <iradiogroup dictcode="app_dist_channel" v-model="submitModel.distchannel"></iradiogroup>
            </td>
          </tr>

          <tr class="row-line">
            <td class="td-label">App加固</td>
            <td>
              <RadioGroup v-model="submitModel.reinforce">
                <Radio :label=1>已加固</Radio>
                <Radio :label=0>未加固</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">应用版本</td>
            <td>
              <Input v-model="submitModel.appversion" />
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">开发工具</td>
            <td>
              <iradiogroup dictcode="android_dev_ide" v-model="submitModel.ide"></iradiogroup>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">IDE版本</td>
            <td>
              <Input v-model="submitModel.ideversion" />
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">自测情况</td>
            <td>
              <RadioGroup v-model="submitModel.selftest">
                <Radio :label="1">已自测</Radio>
                <Radio :label="0">未自测</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line" v-show="submitModel.selftest == 1">
            <td class="td-label">自测设备</td>
            <td>
              <Input v-model="submitModel.testdevice" />
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">开发者</td>
            <td>
              <Input v-model="submitModel.developername"></Input>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">更新说明</td>
            <td>
              <Input v-model="submitModel.updateinfo" type="textarea" :rows="3"></Input>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">手动上传原因</td>
            <td>
              <Input v-model="submitModel.manualreason" type="textarea" :rows="3"></Input>
            </td>
          </tr>
        </table>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="addSubmit">提交</Button>
      </div>
    </Modal>
    <Modal v-model="showPopup" title="下载码" class="centered-modal">
      <div class="verification-code">
        <div v-for="(char, index) in verificationCode" :key="index" class="code-box">
          {{ char }}
        </div>
      </div>
      <div slot="footer">
        当前下载码将在<span class="expiration-time">{{ codeexpiretime }}</span>后过期
        <Button type="primary" size="large" @click="closePopup" class="confirm-button">确定</Button>
        <Button type="primary" size="large" @click="copycode" class="copy-button">复制</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import iradiogroup from "../../components/iradiogroup";
export default {
  components: { iradiogroup },
  data() {
    return {
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          // {
          //   type: "selection",
          //   width: 60,
          //   align: "center"
          // },
          // {
          //   type: "index",
          //   width: 60,
          //   align: "center"
          // },
          {
            title: "应用版本号",
            key: "appversion"
          },
          {
            title: "IDE",
            key: "ide"
          },
          {
            title: "发布类型",
            key: "disttype",
            slot: "disttype"
          },
          {
            title: "发布渠道",
            key: "distchannel"
          },
          {
            title: "构建来源",
            key: "buildfrom",
            slot: "buildfrom"
          },
          {
            title: "开发者",
            key: "developername"
          },
          {
            title: "创建日期",
            key: "createtime"
          },
          {
            title: "操作",
            slot: "copy",
            align: "center"
          },
        ]
      },
      submitModel: {},
      currentDisplayName:"",
      modal: false,
      fileUpload: {
        hasUpload: false,
        fileUploadParams: {
          clientguid: this.$route.params.projectguid,
          userguid: localStorage.userguid
        },
        headers: {
          Authorization: localStorage.token
        },
        uploadurl: this.$axios.defaults.baseURL + "/mqms/file/upload"
      },
      showPopup: false,
      verificationCode: '',
      codeexpiretime:"",
    };
  },
  props: ["approwid"],
  methods: {
    showSubmitFrom(){
      this.submitModel.developername = this.currentDisplayName;
      this.modal = true;
    },
    onModalVisible(visible) {
      if (!visible) {
        this.submitModel = {
          developername:this.currentDisplayName
        };
        this.fileUpload.hasUpload = false;
        this.$refs.uploadApk.clearFiles();
      }
    },
    addSubmit() {
      let _this = this;
      this.submitModel.approwid = this.approwid;
      this.$http.post({
        method: "mqms/androiddist/add",
        params: this.submitModel,
        success: function(data) {
          _this.modal = false;
          _this.getArchiveList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    onApkFileUploadSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.fileUpload.hasUpload = true;
        this.submitModel.filetag = response.data.id;
        this.$refs.uploadApk.clearFiles();
      } else {
        this.$Message.warning({
          title: "提示",
          content: response.msg
        });
      }
    },
    getArchiveList() {
      let _this = this;
      this.$http.get({
        method: "mqms/androiddist/list",
        params: {
          approwid: this.approwid
        },
        success: function(data) {
          _this.tdata.current_data = data;
        },
        failure(code, msg) {}
      });
    },
    rowSelect(row) {
      window.open("#/apkdistdetail/" + row.id);
    },
    copy(row) {
      this.modal = true;
      this.submitModel = row;
      this.submitModel.disttype = Number(row.disttype);
      this.submitModel.filetag = null;
    },
    getcode(row) {
      let _this = this;
      this.$http.post({
        method: "mqms/project/getcode",
        params: {
          filetag: row.filetag,
          disttype: "android",
        },
        success: function(data) {
          _this.verificationCode = data.downloadcode;
          const codecreatetime = new Date(data.codetime);
          const currentTime = new Date(); // 当前时间
          const expirationTime = new Date(codecreatetime.getTime() + (8 * 60 * 60 * 1000)); // 过期时间（8小时后）
          const timeDiffInMillis = expirationTime - currentTime; // 计算剩余时间（毫秒）
          const hours = Math.floor(timeDiffInMillis / (1000 * 60 * 60)); // 获取小时部分
          const minutes = Math.floor((timeDiffInMillis / (1000 * 60)) % 60); // 获取分钟部分
          _this.codeexpiretime = hours + '小时 ' + minutes + '分钟'; // 格式化时间差
           _this.showPopup = true;
        },
        failure(code, msg) {
          _this.$Message.error({
          content:msg,
        })
        }
      });
    },
    closePopup() {
      this.showPopup = false;
    },
    copycode() {
      var input = document.createElement("input"); // 创建input对象
      input.value = this.verificationCode; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$Message.success({
          title: "提示",
          content: "复制成功"
      });
      this.showPopup = false;
    },
    copyapkinfo() {
      // const project = `【新点移动研发过程管理】${this.prj.projectname}`;
      // const appName = `应用名称：${this.app.appname}`;
      // const appVersion = `应用版本：${this.detail.appversion}`;
      // const downloadPage = `下载地址：http://218.4.136.119:8098/#/apkdistdetail/${this.detail.id}`;
      // const downloadCode = `下载码：${this.enteredCode}`;
      // const textToCopy = `${project}\n${appName}\n${appVersion}\n${downloadPage}\n${downloadCode}`;

      // const textarea = document.createElement('textarea');
      // textarea.value = textToCopy;
      // textarea.setAttribute('readonly', '');
      // textarea.style.position = 'absolute';
      // textarea.style.left = '-9999px';
      // textarea.style.whiteSpace = 'pre-wrap'; // 设置样式以保持换行
      // document.body.appendChild(textarea);
      // textarea.select();
      // document.execCommand('copy');
      // document.body.removeChild(textarea);
      // this.$Message.success({
      //     title: "提示",
      //     content: "复制成功"
      // });
    },
    //获取用户信息
    getUserInfo() {
      let _this = this;
      this.$http.get({
        method: "base/user/userinfo",
        params: {},
        success: function (data) {
          _this.currentDisplayName = data.displayname;
          // _this.user.rolename = data[2];
        },
        failure(code, msg) {},
      });
    },
  },
  mounted() {
    this.getArchiveList();
    this.getUserInfo();
  }
};
</script>